module.exports = __webpack_public_path__ + "img/1KOaj3UV6bQDsQZ-t8OpFyn1B-B_T14N.f6ede82c.jpg";